var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 30,
    height: 30,
    viewBox: "0 0 124.273 124.273",
    style: {
      enableBackground: "new 0 0 124.273 124.273"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.51,
    cy: 19.469,
    r: 12.097
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.555,34.51c-0.201-0.124-0.415-0.212-0.627-0.303c-1.348-0.899-2.862-1.562-4.404-1.94l-3.014,3.034l-2.921-3.067       c-0.011,0.003-0.021,0.003-0.03,0.006c-2.237,0.535-4.409,1.667-6.108,3.26c-9.327,6.272-13.299,14.584-15.964,32.766       c-0.378,2.565,1.399,4.951,3.965,5.328c0.229,0.035,0.461,0.051,0.687,0.051c2.294,0,4.298-1.68,4.64-4.016       c0.961-6.543,2.07-11.322,3.352-14.934v14.788c0,1.264,0.245,2.442,0.675,3.526c-0.033,0.244-0.057,0.49-0.057,0.744l0.004,44.969       c0,3.065,2.485,5.551,5.55,5.551c3.067,0,5.551-2.485,5.551-5.551l-0.002-38.594c0.22,0.01,0.438,0.028,0.66,0.028       c0.043,0,0.086-0.006,0.13-0.006l-0.002,38.571c0,3.065,2.485,5.551,5.552,5.551c3.063,0,5.549-2.485,5.549-5.551l0.002-44.695       c0.727-1.348,1.15-2.872,1.15-4.544V53.308c1.503,3.75,2.783,8.905,3.872,16.321c0.341,2.336,2.349,4.016,4.641,4.016       c0.228,0,0.456-0.016,0.687-0.049c2.566-0.377,4.342-2.763,3.965-5.33C55.246,49.113,50.993,40.911,40.555,34.51z        M32.481,59.242l-2.917-3.992l2.261-15.105c0.225-0.607,0.322-1.252,0.284-1.904l0.372-2.491h0.058l2.918,19.501l-2.918,3.992       L32.481,59.242L32.481,59.242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.568,0H57.679c-2.359,0-4.271,1.912-4.271,4.269v30.828c0,2.358,1.911,4.27,4.271,4.27h1.361l-3.363,8.111l9.57-8.111       h47.32c2.357,0,4.27-1.912,4.27-4.27V4.269C116.837,1.912,114.926,0,112.568,0z        M60.804,30.584l-1.796-2.816l3.204-2.042l1.794,2.817L60.804,30.584z        M67.194,26.511l-1.796-2.818l3.836-2.446l1.798,2.819L67.194,26.511z        M108.278,22.041l-3.26-0.736l1.383-6.123L89.655,29.093l-6.659-12.657l-9.623,6.137l-1.798-2.817l12.688-8.09l6.431,12.222       l13.396-11.129l-5.213,0.738l-0.47-3.309l12.96-1.837L108.278,22.041z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockSplit);
export default __webpack_public_path__ + "static/media/StockSplit.ecf310fe820e576b6aea18282b4a8c4f.svg";
export { ForwardRef as ReactComponent };